import {createSelector} from 'reselect';

const socialButtonEnabledSelector = createSelector(
  (state) => state.gsConfig?.features,
  (features = {}) => !!features['login.socialButtonEnabled']
);

export {socialButtonEnabledSelector};
